import { render, staticRenderFns } from "./Districombtp.vue?vue&type=template&id=69eebf78&"
import script from "./Districombtp.vue?vue&type=script&lang=js&"
export * from "./Districombtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports